import { namedQueryKeyWithId } from "../../../ReactQuery/namedQueryKeyWithId";

export const rateAgreementBidPackWithIdQueryKey = (
  rateAgreementId: string | number | undefined
) => [...namedQueryKeyWithId("rateAgreements", rateAgreementId), "bidPacks"];
